export default __webpack_public_path__ + "static/media/Feature2.bc75c2cf.svg";